export default "__VITE_ASSET__CST5hEGv__";